import { render } from "./ExhibitorList.vue?vue&type=template&id=0fda597b&scoped=true"
import script from "./ExhibitorList.vue?vue&type=script&lang=js"
export * from "./ExhibitorList.vue?vue&type=script&lang=js"

import "./ExhibitorList.vue?vue&type=style&index=0&id=0fda597b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fda597b"]])

export default __exports__